import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import NewBid from "@/pages/NewBid";
import BidDetail from "@/pages/BidDetail";
import Profile from "@/pages/Profile";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";

function FullLoader() {
  return (
    <div className="min-h-screen bg-[#0B0F1A] flex items-center justify-center">
      <div className="w-10 h-10 rounded-full border-2 border-[#2563EB] border-t-transparent animate-spin" />
    </div>
  );
}

function Protected({ children, staffOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (staffOnly && user.role !== "admin" && user.role !== "staff") return <Navigate to="/panel" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Layout><Landing /></Layout>} />
            <Route path="/login" element={<Layout><Login /></Layout>} />
            <Route path="/registro" element={<Layout><Register /></Layout>} />
            <Route path="/panel" element={<Protected><Dashboard /></Protected>} />
            <Route path="/panel/nueva" element={<Protected><NewBid /></Protected>} />
            <Route path="/panel/solicitud/:id" element={<Protected><BidDetail /></Protected>} />
            <Route path="/perfil" element={<Protected><Profile /></Protected>} />
            <Route path="/pago/exito" element={<Protected><PaymentResult kind="success" /></Protected>} />
            <Route path="/pago/cancelado" element={<Protected><PaymentResult kind="cancel" /></Protected>} />
            <Route path="/admin" element={<Protected staffOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
